<template>
  <AppSelect
    design="new"
    aria-label="Sales manager"
    :value="value"
    :options="options"
    :reduce="manager => manager.id"
    :filterable="false"
    :loading="loading"
    :dropdown-should-open="dropdownShouldOpen"
    label="name"
    placeholder="Sales manager"

    @input="$emit('input', $event)"
    @open="$emit('open')"
    @search="$emit('search', $event)"
  >
    <template #no-options="{ search }">
      <div class="select__noty ui-select-state">
        <span v-if="loading">Loading managers...</span>
        <template v-else-if="error">
          <span>Unable to load managers.</span>
          <button type="button" @click.stop="$emit('retry')">Retry</button>
        </template>
        <span v-else>{{ search ? 'No managers found' : 'No sales managers' }}</span>
      </div>
    </template>

    <template #list-footer>
      <li v-if="error && options.length" class="ui-select-footer">
        <span>Loading failed.</span>
        <button type="button" @click.stop="$emit('retry')">Retry</button>
      </li>
      <li v-else-if="hasMore || loadingMore" class="ui-select-footer">
        <button
          type="button"
          :disabled="loadingMore"
          @click.stop="$emit('load-more')"
        >
          {{ loadingMore ? 'Loading...' : 'Show more managers' }}
        </button>
      </li>
    </template>
  </AppSelect>
</template>

<script>
import AppSelect from '@/components/AppSelect.vue'

export default {
  name: 'LeadFlowManagerSelect',
  components: {
    AppSelect
  },
  props: {
    value: {
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    error: {
      default: null
    }
  },
  methods: {
    dropdownShouldOpen({ noDrop, open }) {
      return !noDrop && open
    }
  }
}
</script>
